import L from 'leaflet';
import rbush from 'rbush';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';

if (typeof window !== 'undefined') {
  (window as any).L = (window as any).L || L;
  const rbushFn = typeof rbush === 'function' ? rbush : (rbush as any).default || rbush;
  (window as any).RBush = (window as any).RBush || rbushFn;
  (window as any).rbush = (window as any).rbush || rbushFn;
}

if (typeof globalThis !== 'undefined') {
  (globalThis as any).L = (globalThis as any).L || L;
}

export default L;

